import { NextPage } from "next";
import { NextSeo } from "next-seo";
import styled from "styled-components";
import { createTitle } from "../components/app/DefaultSEO";

const Wrapper = styled.div`
  width: 100%;
  min-height: var(--page-min-height);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Text = styled.h1`
  font-size: 22px;
  max-width: 200px;
  text-align: center;
  a {
    color: grey;
    text-decoration: underline;
  }
`;

const ContactPreviewPage: NextPage = () => {
  return (
    <>
      <NextSeo title={createTitle("Contact")} />
      <Wrapper>
        <Text>
          Contact us on{" "}
          <a href="https://www.instagram.com/f_ce_guy/">Instagram</a> or send an{" "}
          <a href="mailto:eliascorynen@hotmail.be">email</a>.
        </Text>
      </Wrapper>
    </>
  );
};

export default ContactPreviewPage;
